module.exports = __webpack_public_path__ + "f9fee93fd03838908f041bdb2801d0e1.png";